var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 176C368 78.797 289.203 0 192 0C94.799 0 16 78.797 16 176C16 262.258 78.1 333.887 160 348.953V384H112C103.164 384 96 391.162 96 400V432C96 440.836 103.164 448 112 448H160V496C160 504.836 167.164 512 176 512H208C216.838 512 224 504.836 224 496V448H272C280.838 448 288 440.836 288 432V400C288 391.162 280.838 384 272 384H224V348.953C305.902 333.887 368 262.258 368 176ZM192 272C139.066 272 96 228.934 96 176C96 123.064 139.066 80 192 80C244.936 80 288 123.064 288 176C288 228.934 244.936 272 192 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/venus.4959c0c25bc27b50297a87e1190d8852.svg";
export { ForwardRef as ReactComponent };